import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { CountryNamePipe } from '@core/pipes/country-name.pipe';
import { LocationFieldComponent } from './location-field.component';


@NgModule({
  imports: [
    CommonModule,
    NgbPopoverModule,
    RouterModule,
    CountryNamePipe
  ],
  declarations: [
    LocationFieldComponent,
  ],
  exports: [
    LocationFieldComponent,
  ],
})
export class LocationsExportModule {}
